import AgeGroupItem from './AgeGroupItem';

export default AgeGroupItem;
